/* tslint:disable */
/* eslint-disable */
/**
 * Mark As Already Had Appointment
 * Mark As Already Had Appointment
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MarkAsAlreadyHadAppointmentRequest,
    MarkAsAlreadyHadAppointmentRequestFromJSON,
    MarkAsAlreadyHadAppointmentRequestToJSON,
} from '../models';

export interface MarkAsAlreadyHadAppointmentPostRequest {
    markAsAlreadyHadAppointmentRequest: MarkAsAlreadyHadAppointmentRequest;
}

/**
 * 
 */
export class MarkAsAlreadyHadAppointmentApi extends runtime.BaseAPI {

    /**
     * Mark As Already Had Appointment
     * Mark As Already Had Appointment
     */
    async markAsAlreadyHadAppointmentPostRaw(requestParameters: MarkAsAlreadyHadAppointmentPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.markAsAlreadyHadAppointmentRequest === null || requestParameters.markAsAlreadyHadAppointmentRequest === undefined) {
            throw new runtime.RequiredError('markAsAlreadyHadAppointmentRequest','Required parameter requestParameters.markAsAlreadyHadAppointmentRequest was null or undefined when calling markAsAlreadyHadAppointmentPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/mark-as-already-had-appointment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkAsAlreadyHadAppointmentRequestToJSON(requestParameters.markAsAlreadyHadAppointmentRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark As Already Had Appointment
     * Mark As Already Had Appointment
     */
    async markAsAlreadyHadAppointmentPost(requestParameters: MarkAsAlreadyHadAppointmentPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.markAsAlreadyHadAppointmentPostRaw(requestParameters, initOverrides);
    }

}
